import * as Sentry from "@sentry/react";
import { APP_VERSION } from "../shared/version";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    release: `palnia@${APP_VERSION}`,
    environment: import.meta.env.DEV ? "development" : "production",
    enabled: !import.meta.env.DEV,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
